import React, { Fragment } from 'react'
import { func, bool } from 'prop-types'

import EmbedTrigger from './EmbedTrigger'

function EmbedTriggersList({ openModal, hasSupportedFileTypes, isGenerating, hasAutoGeneratedViewer }) {
  const embedTypes = [
    { slug: 'youtube', title: 'Youtube' },
    { slug: 'vimeo', title: 'Vimeo' },
    { slug: 'marmoset', title: 'Marmoset' },
  ]

  const showGenerateViewer = hasSupportedFileTypes && !isGenerating && !hasAutoGeneratedViewer

  return (
    <Fragment>
      {embedTypes.map(embed => (
        <div className="col-12 col-sm-6 col-md-3 col-xl-2 col-lg-3" key={embed.slug}>
          <EmbedTrigger
            openModal={openModal}
            embed={embed}
            logoPath={require(`images/${embed.slug}-logo-grey.png`)}
          />
        </div>
      ))}

      {showGenerateViewer && (
        <div className="col-12 col-sm-6 col-md-3 col-xl-2 col-lg-3">
          <EmbedTrigger
            openModal={openModal}
            embed={{ slug: 'generate-viewer', title: '3D viewer' }}
            ctaText="+ Generate 3D viewer"
          />
        </div>
      )}

      {isGenerating && (
        <div className="col-12 col-sm-6 col-md-3 col-xl-2 col-lg-3">
          <div className="embed-trigger embed-trigger--generating">
            <div className="embed-trigger__spinner" />
            <div className="embed-trigger__cta">Generating 3D viewer...</div>
          </div>
        </div>
      )}
    </Fragment>
  )
}

EmbedTriggersList.propTypes = {
  openModal: func.isRequired,
  hasSupportedFileTypes: bool,
  isGenerating: bool,
  hasAutoGeneratedViewer: bool,
}

export default EmbedTriggersList
